"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_SEARCH_BY_WORK_CRITERIA = void 0;
const mobx_1 = require("mobx");
const searchAPI = __importStar(require("@App/api/routes/search"));
const calc_num_pages_1 = require("@App/helpers/pagination/calc-num-pages");
const get_search_query_1 = require("@App/helpers/get-search-query");
const search_criteria_store_1 = __importDefault(require("@App/stores/search/search-criteria-store"));
const search_option_type_1 = require("@App/enum/search-option-type");
const required_criteria_1 = require("@App/enum/required-criteria");
const get_num_titles_1 = require("@App/helpers/pagination/get-num-titles");
const find_page_on_limit_change_1 = require("@App/helpers/pagination/find-page-on-limit-change");
const work_1 = require("@App/api/routes/work");
exports.DEFAULT_SEARCH_BY_WORK_CRITERIA = [
    {
        id: get_search_query_1.SEARCH_WORK_OPTIONS[0].id,
        searchTerm: '',
        isFixed: true,
        selectedOption: get_search_query_1.SEARCH_WORK_OPTIONS[0],
        hasAutocomplete: true,
    },
];
class PublicSearchWorksStore {
    createWorkSearchCriteriaStore() {
        const workSearchMaxCriteria = 5;
        return new search_criteria_store_1.default(exports.DEFAULT_SEARCH_BY_WORK_CRITERIA, get_search_query_1.SEARCH_WORK_OPTIONS, search_option_type_1.SearchOptionType.primary, required_criteria_1.RequiredCriteria.first, workSearchMaxCriteria, [], this.getAutoCompleteSuggestions);
    }
    constructor(rootStore) {
        Object.defineProperty(this, "rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_publicSearchByWorkSearchQuery", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_publicSearchByWorkCriteriaWorks", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_publicSearchByWorkCriteriaPaginationInfo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_currentResultsPerPageLimit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_currentPage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_currentSearchCriteriaStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_redirectingToCatalog", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        (0, mobx_1.makeObservable)(this, {
            _publicSearchByWorkCriteriaWorks: mobx_1.observable,
            _currentSearchCriteriaStore: mobx_1.observable,
            publicSearchByWorkSearchQuery: mobx_1.computed,
            numTitles: mobx_1.computed,
            setRedirectingToCatalog: mobx_1.action,
            resetPublicSearchByWorkCriteriaIfNeeded: mobx_1.action,
            resetSearchResults: mobx_1.action,
            setCurrentPage: mobx_1.action,
        });
        this.rootStore = rootStore;
        this.resetPublicSearchByWorkCriteriaIfNeeded();
    }
    get searchCriteriaStore() {
        return this._currentSearchCriteriaStore;
    }
    resetSearchCriteriaStore() {
        this._currentSearchCriteriaStore = this.createWorkSearchCriteriaStore();
    }
    get publicSearchByWorkSearchQuery() {
        return this._publicSearchByWorkSearchQuery;
    }
    get publicSearchByWorkCriteriaWorks() {
        return this._publicSearchByWorkCriteriaWorks;
    }
    get publicSearchByWorkCriteriaPaginationInfo() {
        return this._publicSearchByWorkCriteriaPaginationInfo;
    }
    get currentResultsPerPageLimit() {
        return this._currentResultsPerPageLimit;
    }
    setPublicSearchByWorkQuery(publicSearchByWorkSearchQuery) {
        this._publicSearchByWorkSearchQuery = publicSearchByWorkSearchQuery;
    }
    get numTitles() {
        var _a, _b;
        return this._publicSearchByWorkCriteriaPaginationInfo
            ? (0, get_num_titles_1.getNumTitles)((_b = (_a = this._publicSearchByWorkCriteriaWorks) === null || _a === void 0 ? void 0 : _a.count) !== null && _b !== void 0 ? _b : 0, this._publicSearchByWorkCriteriaPaginationInfo.currentPage, this._currentResultsPerPageLimit)
            : null;
    }
    getAutoCompleteSuggestions(property, searchTerm) {
        return __awaiter(this, void 0, void 0, function* () {
            const suggestions = yield (0, work_1.searchSuggestions)(property, searchTerm);
            return suggestions.data || [];
        });
    }
    searchForWorks() {
        return __awaiter(this, arguments, void 0, function* (pagination = {
            page: this._currentPage,
            limit: this._currentResultsPerPageLimit,
        }) {
            this.resetSearchResults();
            const response = yield this.searchForWorksApiCall(pagination);
            (0, mobx_1.runInAction)(() => {
                this._publicSearchByWorkCriteriaWorks = response;
                if (pagination.limit && pagination.page && response) {
                    this._publicSearchByWorkCriteriaPaginationInfo = (0, calc_num_pages_1.calcNumPages)(response.count, pagination.limit, pagination.page, pagination.refined);
                }
            });
        });
    }
    searchForWorksApiCall() {
        return __awaiter(this, arguments, void 0, function* (pagination = {
            page: this._currentPage,
            limit: this._currentResultsPerPageLimit,
        }) {
            try {
                const apiResponse = yield searchAPI.searchWorks(pagination, this.publicSearchByWorkSearchQuery);
                return { count: apiResponse.data.totalElements, works: apiResponse.data.content };
            }
            catch (e) {
                this.rootStore.popupStore.setAlertFromError(e);
                return undefined;
            }
        });
    }
    setCurrentPage(page) {
        this._currentPage = page;
    }
    onChangeLimit(newLimit) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._publicSearchByWorkCriteriaWorks) {
                const pagination = { page: this._currentPage, limit: this._currentResultsPerPageLimit };
                const newPage = (0, find_page_on_limit_change_1.findPageOnLimitChange)(pagination, this._publicSearchByWorkCriteriaWorks.count, newLimit, 1);
                this.setCurrentPage(newPage);
            }
            this._currentResultsPerPageLimit = newLimit;
            yield this.searchForWorks();
        });
    }
    get redirectingToCatalog() {
        return this._redirectingToCatalog;
    }
    setRedirectingToCatalog(value) {
        this._redirectingToCatalog = value;
    }
    resetPublicSearchByWorkCriteriaIfNeeded() {
        if (!this.redirectingToCatalog) {
            this._currentPage = 1;
            this._currentResultsPerPageLimit = 10;
            this.resetSearchCriteriaStore();
            this._publicSearchByWorkSearchQuery = {};
            this.resetSearchResults();
        }
        this.setRedirectingToCatalog(false);
    }
    resetSearchResults() {
        this._publicSearchByWorkCriteriaWorks = undefined;
        this._publicSearchByWorkCriteriaPaginationInfo = undefined;
    }
}
exports.default = PublicSearchWorksStore;
